import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  showIcon?: boolean;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  showIcon = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-sm font-medium tracking-wide transition-all duration-300 ease-out rounded-sm';
  const variants = {
    primary: 'bg-brand-champagne text-white hover:bg-[#c49d71] shadow-soft hover:shadow-lg hover:-translate-y-0.5',
    secondary: 'bg-brand-violet text-white hover:bg-[#a691b4] shadow-soft hover:shadow-lg hover:-translate-y-0.5',
    outline: 'border border-brand-champagne text-brand-champagne hover:bg-brand-champagne hover:text-white'
  };
  return <a href="https://shop.viajeatuinterior.online/cart/43576136040526:1?storefront=true" onClick={() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart');
    }
  }} className={`${baseStyles} ${className} bg-[#4A1D6E] text-[#F5F1E8] hover:bg-[#5A2D7E] shadow-lg hover:shadow-xl hover:-translate-y-0.5 cursor-pointer`} {...props} data-id="element-331">
      {children}
      {showIcon && <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-332" />}
    </a>;
}